import { debounce } from "lodash/function";

class AlertFilterSystem {
    constructor() {
        this.initElements();
        this.initMasonry();
        this.initEventListeners();
        this.initDateRangePicker();
        this.submitForm(true);
        this.handleResponsiveLayout();
        window.addEventListener('resize', debounce(() => this.handleResponsiveLayout(), 300));
    }

    initElements() {
        this.currentLayout = 'grid';
        this.grid = document.querySelector('.grid');
        this.typeSelect = document.querySelector("#typeDropdown");
        this.orderSelect = document.querySelector("#orderDropdown");
        this.typeOptions = this.typeSelect.querySelectorAll(".select-options li");
        this.orderOptions = this.orderSelect.querySelectorAll(".select-options li");
        this.searchInput = document.querySelector('input[name="search"]');
        this.form = document.getElementById('alertsFilterForm');
        this.typeInput = document.getElementById('typeInput');
        this.orderInput = document.getElementById('orderInput');
        this.dateRangeInput = document.getElementById('daterange');
        this.articlesResult = document.getElementById('articlesResult');
        this.noResultsElement = document.getElementById('noResults');
        this.buttons = document.querySelectorAll('.toggle-btn');
    }

    initMasonry() {
        this.msnry = new Masonry(this.grid, {
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer',
            percentPosition: true
        });
    }

    initEventListeners() {
        this.searchInput.addEventListener('input', debounce(() => this.submitForm(), 300));

        this.typeSelect.addEventListener("click", (e) => this.toggleDropdown(e, this.typeSelect));
        this.orderSelect.addEventListener("click", (e) => this.toggleDropdown(e, this.orderSelect));

        this.typeOptions.forEach(option => {
            option.addEventListener("click", () => this.handleOptionSelect(option, this.typeSelect, this.typeInput));
        });

        this.orderOptions.forEach(option => {
            option.addEventListener("click", () => this.handleOptionSelect(option, this.orderSelect, this.orderInput));
        });

        document.addEventListener("click", (e) => this.handleOutsideClick(e));

        this.buttons.forEach(btn => {
            btn.addEventListener('click', () => {
                this.handleLayoutToggle(btn);
            });
        });

        this.grid.classList.add('grid-view');
    }

    initDateRangePicker() {
        $('#daterange').daterangepicker({
            autoUpdateInput: false,
            ranges: {
                'Hoy': [moment(), moment()],
                'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
                'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
                'Este mes': [moment().startOf('month'), moment().endOf('month')],
                'Mes pasado': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            locale: this.getDatePickerLocale(),
            minYear: 2000,
            maxYear: (parseInt(moment().format('YYYY')) + 2),
            showDropdowns: true,
            alwaysShowCalendars: true,
            opens: 'left',
            buttonClasses: '',
            applyButtonClasses: '',
            cancelButtonClasses: ''
        }, (start, end) => {
            $('#daterange').val(`${start.format('DD/MM/YYYY')} - ${end.format('DD/MM/YYYY')}`);
        });

        $('#daterange').on('apply.daterangepicker', () => this.submitForm());
        $('#daterange').on('cancel.daterangepicker', () => {
            $('#daterange').val('');
            this.submitForm();
        });
    }

    getDatePickerLocale() {
        return {
            format: "DD/MM/YYYY",
            separator: " - ",
            applyLabel: 'Aplicar',
            cancelLabel: 'Cancelar',
            customRangeLabel: 'Rango personalizado',
            weekLabel: "S",
            daysOfWeek: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
            monthNames: [
                'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
            ],
            firstDay: 1
        };
    }

    toggleDropdown(e, dropdown) {
        e.stopPropagation();
        dropdown.classList.toggle("open");
    }

    handleLayoutToggle(clickedBtn) {
        if (window.innerWidth < 768) return;

        this.buttons.forEach(b => b.classList.remove('active'));
        clickedBtn.classList.add('active');

        const isListLayout = clickedBtn.querySelector('img[alt="list"]');
        this.currentLayout = isListLayout ? 'list' : 'grid';

        this.grid.classList.toggle('list-view', isListLayout);
        this.grid.classList.toggle('grid-view', !isListLayout);

        setTimeout(() => {
            this.msnry.reloadItems();
            this.msnry.layout();
        }, 100);
    }
    handleResponsiveLayout() {
        this.msnry.reloadItems();
        this.msnry.layout();

        if (window.innerWidth < 768) {
            this.grid.classList.remove('list-view');
            this.grid.classList.add('grid-view');

            this.buttons.forEach(b => b.classList.remove('active'));
            const gridBtn = Array.from(this.buttons).find(btn =>
                btn.querySelector('img[alt="grid"]')
            );
            if (gridBtn) gridBtn.classList.add('active');

            setTimeout(() => {
                this.msnry.reloadItems();
                this.msnry.layout();
            }, 100);
        } else {
            if (this.currentLayout === 'list') {
                this.grid.classList.add('list-view');
                this.grid.classList.remove('grid-view');
            } else {
                this.grid.classList.add('grid-view');
                this.grid.classList.remove('list-view');
            }
        }
    }
    handleOptionSelect(option, dropdown, input) {
        const selected = dropdown.querySelector('.selected');
        selected.textContent = option.textContent;
        input.value = option.getAttribute('data-slug');
        dropdown.classList.remove("open");
        this.submitForm();
    }

    handleOutsideClick(e) {
        if (!this.typeSelect.contains(e.target)) {
            this.typeSelect.classList.remove("open");
        }
        if (!this.orderSelect.contains(e.target)) {
            this.orderSelect.classList.remove("open");
        }
    }

    createArticleElement(article) {
        const articleElement = document.createElement('div');
        articleElement.className = 'grid-item card';
        articleElement.innerHTML = `
      <div class="card__content">
        <div class="card__text">
          <div class="date">${article.date} <span class="cn_code">${article.cn_code}</span></div>
          <h3>${article.title}</h3>
          ${article.subtitle ? `<div><p class="subtitle">${article.subtitle}</p></div>` : ''}
          ${article.pdf_file ? `<div class="downloads"><a href="${article.pdf_file}" target="_blank">Descargar PDF</a></div>` : ''}
        </div>
      </div>
    `;
        return articleElement;
    }

    clearGridItems() {
        document.querySelectorAll('.grid-item').forEach(item => {
            if (!item.classList.contains('grid-sizer')) {
                item.remove();
            }
        });
    }

    renderArticles(articles) {
        this.clearGridItems();

        articles.forEach(article => {
            const articleElement = this.createArticleElement(article);
            this.grid.appendChild(articleElement);
        });

        imagesLoaded(this.grid, () => {
            this.msnry.reloadItems();
            this.msnry.layout();
        });
    }

    async submitForm(ignoreData = false) {
        try {
            const payload = this.buildPayload(ignoreData);
            const response = await fetch('/alerts/search', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();
            this.handleResponse(data);
        } catch (error) {
            console.error('Error:', error);
            this.articlesResult.innerHTML = '<p class="error">Error al cargar los artículos</p>';
        }
    }

    buildPayload(ignoreData) {
        const formData = new FormData(this.form);
        const dateRange = this.dateRangeInput.value;
        const pageInput = document.getElementById('pageInput');

        const payload = {
            _token: formData.get('_token'),
            type: ignoreData ? '' : this.typeInput.value,
            order: ignoreData ? '' : this.orderInput.value,
            search: ignoreData ? '' : this.searchInput.value,
            page: ignoreData ? 1 : pageInput.value
        };

        if (dateRange && !ignoreData) {
            const dates = dateRange.split(' - ');
            if (dates.length === 2) {
                payload.start_date = dates[0].split('/').reverse().join('-');
                payload.end_date = dates[1].split('/').reverse().join('-');
            }
        }

        return payload;
    }

    handleResponse(data) {
        if (data.data.length === 0) {
            this.clearGridItems();
            this.msnry.reloadItems();
            this.msnry.layout();
            this.articlesResult.innerHTML = '';
            this.noResultsElement.style.display = 'flex';
        } else {
            this.noResultsElement.style.display = 'none';
            this.renderArticles(data.data);
            this.renderPagination(data.pagination);
        }
    }

    renderPagination(pagination) {
        const existingPagination = document.querySelector('.pagination-container');
        if (existingPagination) {
            existingPagination.remove();
        }

        if (pagination.last_page <= 1) return;

        const paginationContainer = document.createElement('div');
        paginationContainer.className = 'pagination-container';

        let paginationHTML = `
        <div class="pagination">
            <button class="pagination-btn ${pagination.current_page === 1 ? 'disabled' : ''}"
                    data-page="${pagination.current_page - 1}" ${pagination.current_page === 1 ? 'disabled' : ''}>
                <
            </button>`;

        for (let i = 1; i <= pagination.last_page; i++) {
            paginationHTML += `
            <button class="pagination-btn ${i === pagination.current_page ? 'active' : ''}"
                    data-page="${i}">
                ${i}
            </button>`;
        }

        paginationHTML += `
            <button class="pagination-btn ${pagination.current_page === pagination.last_page ? 'disabled' : ''}"
                    data-page="${pagination.current_page + 1}" ${pagination.current_page === pagination.last_page ? 'disabled' : ''}>
                >
            </button>
        </div>`;

        paginationContainer.innerHTML = paginationHTML;
        this.grid.parentNode.insertBefore(paginationContainer, this.grid.nextSibling);

        document.querySelectorAll('.pagination-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                if (btn.disabled) return;
                document.getElementById('pageInput').value = btn.dataset.page;
                this.submitForm();
            });
        });
    }
}
document.addEventListener("DOMContentLoaded", () => {
    new AlertFilterSystem();
});
